// BookingTableRow.tsx
import React from 'react';
import moment from 'moment';
import ChefInfoPopover from '../ChefPopover';
interface BookingTableRowProps {
  booking: any;
  index: number;
  bookingControlState: any;
  handleToggleRow: (index: number, e: React.MouseEvent) => void;
  toggleState: (key: string, value: number | null) => void;
  getPopoverTargetId: (index: number, type: string) => string;
  getBookingActions: (props: any) => any;
  setRescheduleBooking: (booking: any) => void;
  setShowRescheduleModal: (val: boolean) => void;
  setCancelBooking: (booking: any) => void;
  setShowCancelPop: (val: boolean) => void;
}

const BookingTableRow: React.FC<BookingTableRowProps> = ({
  booking,
  index,
  bookingControlState,
  handleToggleRow,
  toggleState,
  getPopoverTargetId,
}) => {
  return (
    <tr>
      <td>
        <i
          className={`bi ${
            bookingControlState.openRow === index
              ? 'bi-chevron-up'
              : 'bi-chevron-down'
          }`}
          style={{ cursor: 'pointer', marginRight: '10px', marginLeft: '-10px' }}
          onClick={(e) => handleToggleRow(index, e)}
        ></i>
        {moment(booking.startDate).format('DD/MM/YYYY') || 'N/A'}
      </td>
      <td>
        {booking.startTime
          ? moment(booking.startTime.replace('.', ':'), 'h:mm A').format('hh:mm A')
          : ''}
      </td>
      <td>
        {booking.endTime
          ? moment(booking.endTime.replace('.', ':'), 'h:mm A').format('hh:mm A')
          : ''}
      </td>
      <td>
        {booking.requirement
          ? booking.requirement.charAt(0).toUpperCase() + booking.requirement.slice(1)
          : 'N/A'}
      </td>
      <td>
        {booking?.meals?.map(
          (meal: any) => meal.charAt(0).toUpperCase() + meal.slice(1)
        ).join(', ') || 'N/A'}
      </td>
      <td>
        <span
          id={getPopoverTargetId(index, 'chef')}
          onMouseEnter={() => toggleState('openChefPopover', index)}
          onMouseLeave={() => toggleState('openChefPopover', null)}
          style={{ cursor: booking.chef?.id ? 'pointer' : 'default' }}
        >
          <>
            {booking.chef?.id ? (
              <img src={booking.chef?.image} alt="Chef" className="chef-image" />
            ) : null}
            {booking.chef?.id || 'Unassigned'}
          </>
        </span>
        {booking.chef?.id && (
          <ChefInfoPopover
            chef={booking.chef}
            isOpen={bookingControlState.openChefPopover === index}
            targetId={getPopoverTargetId(index, 'chef')}
          />
        )}
      </td>
      <td>
        {`${booking.billingAddress?.address || 'N/A'}, ${
          booking.billingAddress?.city || 'N/A'
        }, ${booking.billingAddress?.region || 'N/A'}`}
      </td>
      <td>
        <span
          className={`circle ${
            booking.status === 3
              ? 'completed'
              : booking.status === 2
              ? 'pending'
              : booking.status === 1
              ? 'cancelled'
              : ''
          }`}
        ></span>
      </td>
      <td className="d-flex align-items-center justify-content-between">
        <span>{booking.description || 'N/A'}</span>
        {/* {Number(booking.status) === 3 && (
          <EllipsisActionButton
            isOpen={bookingControlState.ellipsisPopover === index}
            toggle={() => toggleState('ellipsisPopover', index)}
            actions={getBookingActions({
              booking,
              setRescheduleBooking,
              setShowRescheduleModal,
              setCancelBooking,
              setShowCancelPop,
            })}
          />
        )} */}
      </td>
    </tr>
  );
};

export default BookingTableRow;